import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { EmpresaProvider } from "./context/EmpresaContext";
import { EmpresaSelectorProvider } from "./context/EmpresaSelectorContext";
import { FinancialProvider } from "./context/FinancialContext";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import DashboardLayout from "./pages/Dashboard/DashboardLayout";
import Dashboard from "./pages/Dashboard/Dashboard";
import CierreCaja from "./pages/Dashboard/CierreCaja";
import Contabilidad from "./pages/Dashboard/Contabilidad/Contabilidad";
import ContabilidadGeneral from "./pages/Dashboard/Contabilidad/ContabilidadGeneral";
import Ingresos from "./pages/Dashboard/Contabilidad/Ingresos";
import Egresos from "./pages/Dashboard/Contabilidad/Egresos";
import Patrimonio from "./pages/Dashboard/Reporte/Patrimonio";
import Resumen from "./pages/Dashboard/Contabilidad/Resumen";
import Reporte from "./pages/Dashboard/Reporte/Reporte";
import FlujoCaja from "./pages/Dashboard/Reporte/FlujoCaja";
import ResumenTotal from "./pages/Dashboard/Reporte/ResumenTotal";
import Cuentas from "./pages/Dashboard/Reporte/Cuentas";
import Productos from "./pages/Dashboard/Inventario/Productos";
import TerminosCondiciones from "./pages/Dashboard/TerminosCondiciones";
import Usuarios from "./pages/Dashboard/Admin/Usuarios";
import Empresas from "./pages/Dashboard/Admin/Empresas";
import ProtectedRoute from "./components/ProtectedRoute";
import CalculoProductos from "./pages/Dashboard/Contabilidad/CalculoProductos";

function App() {
  return (
    <AuthProvider>
      <EmpresaProvider>
        <EmpresaSelectorProvider>
          <FinancialProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/no-autorizado"
                element={<div className="text-center p-8 text-white">No tienes permisos.</div>}
              />

              {/* Home - accesible por todos los roles */}
              <Route
                path="/"
                element={
                  <ProtectedRoute roles={["conexadmin", "administrador", "cliente", "trabajadores"]}>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
              </Route>

              {/* Dashboard - conexadmin, administrador y trabajadores */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute roles={["conexadmin", "administrador", "trabajadores"]}>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                {/* Inventario - conexadmin, administrador, trabajadores */}
                <Route path="inventario" element={<Productos />} />
                
                {/* Ingreso Diario (CierreCaja) - conexadmin, administrador, trabajadores */}
                <Route path="cierrecaja" element={<CierreCaja />} />
                
                {/* Contabilidad - conexadmin, administrador, trabajadores */}
                <Route path="contabilidad" element={<Contabilidad />}>
                  <Route index element={<ContabilidadGeneral />} />
                  <Route path="ingresos" element={<Ingresos />} />
                  <Route path="egresos" element={<Egresos />} />
                  <Route path="patrimonio" element={<Patrimonio />} />
                  <Route path="calculo-productos" element={<CalculoProductos />} />
                  <Route path="resumen" element={<Resumen />} />
                </Route>

                {/* Reporte - SOLO conexadmin y administrador (NO trabajadores) */}
                <Route
                  path="reporte"
                  element={
                    <ProtectedRoute roles={["conexadmin", "administrador"]}>
                      <Reporte />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Reporte />} />
                  <Route path="ingresos" element={<Ingresos />} />
                  <Route path="egresos" element={<Egresos />} />
                  <Route path="patrimonio" element={<Patrimonio />} />
                  <Route path="calculo-productos" element={<CalculoProductos />} />
                  <Route path="resumen" element={<Resumen />} />
                  <Route path="cuentas" element={<Cuentas />} />
                  <Route path="flujo-caja" element={<FlujoCaja />} />
                  <Route path="resumen-total" element={<ResumenTotal />} />
                </Route>

                {/* Administración - SOLO conexadmin */}
                <Route
                  path="admin/usuarios"
                  element={
                    <ProtectedRoute roles={["conexadmin"]}>
                      <Usuarios />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="admin/empresas"
                  element={
                    <ProtectedRoute roles={["conexadmin"]}>
                      <Empresas />
                    </ProtectedRoute>
                  }
                />
                
                <Route path="terminos-condiciones" element={<TerminosCondiciones />} />
              </Route>

              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </FinancialProvider>
        </EmpresaSelectorProvider>
      </EmpresaProvider>
    </AuthProvider>
  );
}

export default App;
